/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type categoriesSection_home$ref: FragmentReference;
export type categoriesSection_home = {|
  +categories: $ReadOnlyArray<{|
    +slug: ?string,
    +name: ?string,
  |}>,
  +categoriesContent: $ReadOnlyArray<{|
    +slug: ?string,
    +title: ?string,
    +caption: ?string,
    +readingTime: ?number,
    +picture: ?string,
    +author: ?{|
      +firstname: ?string,
      +lastname: ?string,
    |},
    +category: ?{|
      +slug: ?string,
      +name: ?string,
      +color: ?string,
    |},
  |}>,
  +categoriesPromoted: {|
    +slug: ?string,
    +name: ?string,
    +color: ?string,
  |},
  +categoriesPromotedPicture: ?string,
  +$refType: categoriesSection_home$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = [
  v0,
  v1,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "color",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "categoriesSection_home",
  "type": "Home",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categories",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": true,
      "selections": [
        v0,
        v1
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categoriesContent",
      "storageKey": null,
      "args": null,
      "concreteType": "Article",
      "plural": true,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "caption",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "readingTime",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "picture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "author",
          "storageKey": null,
          "args": null,
          "concreteType": "Author",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "firstname",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "lastname",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "Category",
          "plural": false,
          "selections": v2
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categoriesPromoted",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": false,
      "selections": v2
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoriesPromotedPicture",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '4001906887493967a76abfc7850b45cf';
module.exports = node;
